class Chronology {
  constructor() {
    this.activeEntry = null;
    this.newEntry = null;
  }

  init() {
    const _this = this;
    Array.from(document.querySelectorAll('.js-chronology-entry')).forEach(
      entry => {
        // Array.from(document.querySelectorAll('.js-chronology-entry')).map(entry => {
        const elementWatcher = scrollMonitor.create(entry, { top: 150 });
        elementWatcher.enterViewport(function() {
          if (_this.newEntry === null && this.belowViewport === true)
            _this.newEntry = this;
        });

        elementWatcher.fullyEnterViewport(function() {
          // Make sure this is definitely the active
          if (_this.activeEntry) {
            _this.activeEntry.watchItem.classList.remove('active');
          }
          _this.activeEntry = this;
          _this.activeEntry.watchItem.classList.add('active');
        });

        elementWatcher.partiallyExitViewport(function() {
          // If the exiting element is the active element, check if another element could be active
          if (_this.activeEntry === this) {
            if (_this.newEntry) {
              this.watchItem.classList.remove('active');
              _this.newEntry.watchItem.classList.add('active');

              // Store new active element
              _this.activeEntry = _this.newEntry;
              _this.newEntry = null;
            }
          }
        });
      }
    );
  }
}

export default Chronology;
